exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".expand-enter-active,.expand-leave-active{transition:height 0.35s cubic-bezier(0.15, 0.5, 0.5, 1);overflow:hidden}.expand-enter,.expand-leave-to{height:0}\n", ""]);

